<template>
  <div class="elr-input-group">
    <p class="elr-control-label">{{label}}:</p>
    <div class="elr-control-group">
      <div v-for="item in values" :key="item.value">
        <label :for="item.value">{{item.label}}</label>
        <input
          :id="item.value"
          :name="fieldName"
          @change="$emit('input', $event.target.value)"
          :value="item.value"
          type="radio"
          :checked="item.value === value"
        >
      </div>
    </div>
    <small class="elr-input-support" v-if="supportText">{{supportText}}</small>
    <small class="error-message" v-if="hasError">
      {{errorMessage}}
    </small>
  </div>
</template>

<script>
export default {
  name: 'InputRadio',
  props: {
    errors: {
      type: Object
    },
    label: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      reqruied: true
    },
    errorMessage: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    supportText: {
      type: String
    },
    value: {
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },
  computed: {
    hasError() {
      return this.inErrors(this.errors, this.fieldName);
    }
  },
  methods: {
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    }
  }
}
</script>

<style scoped>
.elr-form .elr-control-group {
  padding-top: 0;
  padding-bottom: 0;
}

.elr-control-group > div {
  display: flex;
  padding-right: 10px;
}
</style>

